export const pcPageConfig = {
  "pageShowType": "pc",
  "title": "Date Comparison",
  "titleCN": "时间对比",
  "path": "/comparisonAnalysis/dateComparison",
  "defaultTab": "dateComparison",
  "tabList": [
    {
      "id": "dateComparison",
      "tabName": "Date Comparison",
      "tabNameCN": "时间对比",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/dateComparison",
      "path": "/comparisonAnalysis/dateComparison",
      "tabIcon": "",
      "logConfig": {
        "pageId": "201701",
        "pageName": "comparisonAnalysisDateComparison",
        "extInfo": "comparisonAnalysisDateComparison",
        "pagePath": "/comparisonAnalysis/dateComparison"
      },
      "filters": [
        {
          "data": {
            "dataFrame": "pc"
          },
          "name": "DateFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/comparisonAnalysis/dateComparison",
          "componentList": [
            {
              "name": "dateComparisonTrendService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/comparison_analysis/date/linechart",
                  "isDark": true
                },
                "reqMetrics": {
                  "Day": [
                    "total_users",
                    "new_users",
                    "active_users",
                    "net_revenue",
                    "revenue_after_chargeback",
                    "units_number",
                    "gross_revenue",
                    "units_revenue",
                    "mtx_revenue",
                    "mtx_payers",
                    "mtx_payer_rate",
                    "mtx_arpu",
                    "mtx_arppu",
                    "d1",
                    "d2",
                    "d3",
                    "d4",
                    "d5",
                    "d6",
                    "d7",
                    "d14",
                    "d30",
                    "pcu",
                    "acu",
                    "aot_hour",
                    "alc",
                    "retention_users",
                    "churn_users",
                    "churn_rate",
                    "return_users",
                    "weighted_d2",
                    "weighted_d3",
                    "weighted_d7",
                    "weighted_d14",
                    "first_login_ratio",
                    "second_login_ratio",
                  ]
                }
              },
              "children": [
                {
                  "name": "SegmentMoreCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "props": {
                    "config": {
                      "componentSegment": {
                        "Day": [
                          {
                            "value": "total_users",
                            "metric_key": "total_users",
                            "enName": "TNU",
                            "cnName": "总注册用户数",
                            "rainbowKey": "Pc TNU",
                            "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (userid deduplicated).",
                            "explainCn": "累计至统计日的注册用户总数(userid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "new_users",
                            "metric_key": "new_users",
                            "enName": "New",
                            "cnName": "新进用户",
                            "rainbowKey": "Pc New",
                            "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (userid deduplicated).",
                            "explainCn": "统计周期内新注册用户数(userid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "active_users",
                            "metric_key": "active_users",
                            "enName": "DAU",
                            "cnName": "日活跃",
                            "rainbowKey": "Pc DAU",
                            "explainEn": "Daily Active Users.Number of users who have logged in to the game during the statistical period (userid deduplicated).",
                            "explainCn": "统计周期内登录过游戏的用户数(userid数去重)。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "net_revenue",
                            "metric_key": "net_revenue",
                            "enName": "Revenue After Refund & Tax($)",
                            "cnName": "净收入($)",
                            "rainbowKey": "Pc Revenue",
                            "explainEn": "During the statistical period, the net sales revenue of 4 sales platforms, including Steam, Epic, Xbox, and Playstation,Revenue After Refund & Tax excludes refunds and is net of taxes",
                            "explainCn": "统计周期内，4个销售平台的销售净收入，包括Steam 、Epic、Xbox 、Playstation，净收入不包含退款，并且扣除了税费",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "revenue_after_chargeback",
                            "metric_key": "revenue_after_chargeback",
                            "enName": "Revenue After Refund($)",
                            "cnName": "收入(剔除退款)($)",
                            "rainbowKey": "Pc Revenue After Refund($)",
                            "explainEn": "The net sales amount of the game all products (Base Game、 dlc,bundle、 mtx..) is equal to the sum of the sales amount of the game's various platforms,the sales amount of each platform = total sales amount - refund amount,Noted: this amount does not deduct steam/Epic platform share, and does not include the sales amount of retail actiyation code (humble bundle, hevbox...). Data source:Steam/Epic/XBOX/PlayStation platforms Time zone: Steam sales data is in UTC-8 time zone,EpicXBOX/PlayStation sales data is in UTC+0 time zone.",
                            "explainCn": "游戏所有产品（完整游戏、dlc、bundle、mtx...）的净销售额等于游戏各平台销售额的总和，剔除退款金额。注：未扣除平台分成数据且不包含第三方销售渠道的金额（humble Bundle、heybox...）。数据来源： Steam/Epic/XBOX/PlayStation 平台时区： Steam 销售数据采用 UTC-8 时区，Epic/XBOX/PlayStation 销售数据采用 UTC+0 时区",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "units_number",
                            "metric_key": "units_number",
                            "enName": "Base Game Units After Refund",
                            "cnName": "本体拷贝净销量",
                            "rainbowKey": "Pc Units",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "gross_revenue",
                            "metric_key": "gross_revenue",
                            "enName": "Revenue($)",
                            "cnName": "收入($)",
                            "rainbowKey": "Pc Revenue",
                            "explainEn": "Total sales amount Noted：this amount does not deduct steam/Epic platform share, and does not include the sales amount of retail activation code（humble bundle、heybox...). Data source： Steam/Epic/XBOX/PlayStation platforms Time zone： Steam sales data is in UTC-8 time zone,Epic/XBOX/PlayStation sales data is in UTC+0 time zone.",
                            "explainCn": "总销售金额 注：此金额不扣除Steam/Epic平台分成，也不包含零售激活码的销售金额（humble Bundle、heybox...）。数据来源： Steam/Epic/XBOX/PlayStation 平台时区： Steam 销售数据采用 UTC-8 时区，Epic/XBOX/PlayStation 销售数据采用 UTC+0 时区",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "units_revenue",
                            "metric_key": "units_revenue",
                            "enName": "Base Game Revenue After Refund & Tax",
                            "cnName": "本体拷贝收入",
                            "rainbowKey": "Pc Units Revenue",
                            "explainEn": "During the statistical period, the net sales revenue of the game itself includes the sales of the game itself in full game, edition, package and other products. Data Source: Platform Sales Reports",
                            "explainCn": "统计周期内，游戏本体的净销售收入，包括full game，eddition，package等产品里的游戏本体销售额.数据来源：Platform Sales Reports",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "mtx_revenue",
                            "metric_key": "mtx_revenue",
                            "enName": "In-Game Revenue",
                            "cnName": "内购收入",
                            "rainbowKey": "",
                            "explainEn": "The total amounts from microtransactions in the statistical period.",
                            "explainCn": "统计周期内，游戏内购收入总金额",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "mtx_payers",
                            "metric_key": "mtx_payers",
                            "enName": "In-Game Payer",
                            "cnName": "内购付费人数",
                            "rainbowKey": "",
                            "explainEn": "Total number of users who have in-game payment behaviors in the statistical period (deduplicated)",
                            "explainCn": "统计期间内有游戏内付费行为的用户总数（去重）",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "mtx_payer_rate",
                            "metric_key": "mtx_payer_rate",
                            "enName": "In-Game Payer%",
                            "cnName": "内购付费渗透率",
                            "rainbowKey": "",
                            "explainEn": "Number of In-Game paying users/Number of active users during the statistical period",
                            "explainCn": "内购付费人数/统计周期内的活跃人数",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "mtx_arpu",
                            "metric_key": "mtx_arpu",
                            "enName": "In-Game ARPU",
                            "cnName": "内购ARPU",
                            "rainbowKey": "",
                            "explainEn": "In-Game Revenue/Number of active users during the statistical period",
                            "explainCn": "内购收入/统计周期内的活跃人数",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "mtx_arppu",
                            "metric_key": "mtx_arppu",
                            "enName": "In-Game ARPPU",
                            "cnName": "内购付费ARPPU",
                            "rainbowKey": "",
                            "explainEn": "In-Game Revenue/Number of In-Game pay users during the statistical period",
                            "explainCn": "内购收入/统计期间内的内购付费人数",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "d1",
                            "metric_key": "d1",
                            "enName": "D1",
                            "cnName": "D1留存",
                            "rainbowKey": "Pc D1",
                            "explainEn": "The retention rate of new register users on day 1. Number of retained users on day 1 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D1留存=xx注册日期第1天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d2",
                            "metric_key": "d2",
                            "enName": "D2",
                            "cnName": "D2留存",
                            "rainbowKey": "Pc D2",
                            "explainEn": "The retention rate of new register users on day 2. Number of retained users on day 2 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D2留存=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d3",
                            "metric_key": "d3",
                            "enName": "D3",
                            "cnName": "D3留存",
                            "rainbowKey": "Pc D3",
                            "explainEn": "The retention rate of new register users on day 3. Number of retained users on day 3 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D3留存=xx注册日期第3天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d4",
                            "metric_key": "d4",
                            "enName": "D4",
                            "cnName": "D4留存",
                            "rainbowKey": "Pc D4",
                            "explainEn": "The retention rate of new register users on day 4. Number of retained users on day 4 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D4留存=xx注册日期第4天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d5",
                            "metric_key": "d5",
                            "enName": "D5",
                            "cnName": "D5留存",
                            "rainbowKey": "Pc D5",
                            "explainEn": "The retention rate of new register users on day 5. Number of retained users on day 5 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D5留存=xx注册日期第5天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d6",
                            "metric_key": "d6",
                            "enName": "D6",
                            "cnName": "D6留存",
                            "rainbowKey": "Pc D6",
                            "explainEn": "The retention rate of new register users on day 6. Number of retained users on day 6 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D6留存=xx注册日期第6天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d7",
                            "metric_key": "d7",
                            "enName": "D7",
                            "cnName": "D7留存",
                            "rainbowKey": "Pc D7",
                            "explainEn": "The retention rate of new register users on day 7. Number of retained users on day 7 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D7留存=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日是第0天。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d14",
                            "metric_key": "d14",
                            "enName": "D14",
                            "cnName": "D14留存",
                            "rainbowKey": "Pc D14",
                            "explainEn": "The retention rate of new register users on day 14. Number of retained users on day 14 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D14留存=xx注册日期第14天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "d30",
                            "metric_key": "d30",
                            "enName": "D30",
                            "cnName": "D30留存",
                            "rainbowKey": "Pc D30",
                            "explainEn": "The retention rate of new register users on day 30. Number of retained users on day 30 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                            "explainCn": "D30留存=xx注册日期第30天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "pcu",
                            "metric_key": "pcu",
                            "enName": "PCU",
                            "cnName": "最高同时在线",
                            "rainbowKey": "",
                            "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "acu",
                            "metric_key": "acu",
                            "enName": "ACU",
                            "cnName": "平均同时在线",
                            "rainbowKey": "",
                            "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                            "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "aot_hour",
                            "metric_key": "aot_hour",
                            "enName": "Avg.Playtime(h)",
                            "cnName": "平均在线时长(小时)",
                            "rainbowKey": "Pc Avg.Playtime(h)",
                            "explainEn": "",
                            "explainCn": "",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "alc",
                            "metric_key": "alc",
                            "enName": "Sessions per user",
                            "cnName": "平均登录次数",
                            "rainbowKey": "",
                            "explainEn": "Sessions per user.\nDaily: Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly: Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                            "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                            "type": "decimals",
                            "decimal": 2
                          },
                          {
                            "value": "retention_users",
                            "metric_key": "retention_users",
                            "enName": "DAU Retention Users",
                            "cnName": "日活留存",
                            "rainbowKey": "",
                            "explainEn": "The number of users who logged in during the recent 7 days(T-1~T-7) and have logged in to the game during the statistical period (deduplicated).",
                            "explainCn": "日活跃构成中的留存用户数，统计周期前一个周期 前7天(T-1~T-7) 登录了游戏并且在统计周期当期也有登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churn_users",
                            "metric_key": "churn_users",
                            "enName": "Churn Users",
                            "cnName": "日流失",
                            "rainbowKey": "",
                            "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                            "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数\n月：上个月登录了并且在本月未登录的用户数。",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "churn_rate",
                            "metric_key": "churn_rate",
                            "enName": "Churn%",
                            "cnName": "流失率",
                            "rainbowKey": "",
                            "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                            "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "return_users",
                            "metric_key": "return_users",
                            "enName": "DAU Return Users",
                            "cnName": "日回流",
                            "rainbowKey": "",
                            "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                            "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存",
                            "type": "int",
                            "decimal": 0
                          },
                          {
                            "value": "weighted_d2",
                            "metric_key": "weighted_d2",
                            "enName": "Weighted D1",
                            "cnName": "加权D1留存",
                            "rainbowKey": "",
                            "explainEn": "Day 1 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 1 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权D1留存=游戏上线之日起至统计日对（新注册用户数*新增次日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weighted_d3",
                            "metric_key": "weighted_d3",
                            "enName": "Weighted D2",
                            "cnName": "加权D2留存",
                            "rainbowKey": "",
                            "explainEn": "Day 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 2 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权D2留存=游戏上线之日起至统计日对（新注册用户数*新增2日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weighted_d7",
                            "metric_key": "weighted_d7",
                            "enName": "Weighted D6",
                            "cnName": "加权D6留存",
                            "rainbowKey": "",
                            "explainEn": "Day 6 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 6 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权D6留存=游戏上线之日起至统计日对（新注册用户数*新增6日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "weighted_d14",
                            "metric_key": "weighted_d14",
                            "enName": "Weighted D13",
                            "cnName": "加权D13留存",
                            "rainbowKey": "",
                            "explainEn": "Day 13 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 13 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                            "explainCn": "加权D13留存=游戏上线之日起至统计日对（新注册用户数*新增13日留存率）求和/游戏上线之日起至统计日新注册用户数之和。。",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "first_login_ratio",
                            "metric_key": "first_login_ratio",
                            "enName": "1st Order Login%",
                            "cnName": "一阶登录比",
                            "rainbowKey": "",
                            "explainEn": "1st Order Login%: 3-day valid registers / 2-day valid registers.\n2-day valid registers: the number of users who login for at least two days within seven days, starting from the day of registering.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering. Considered as the retention users of 2-day valid registers.",
                            "explainCn": "一阶登录比=3天有效注册用户数/2天有效注册用户数\n2天有效注册用户：从注册日开始计算，七天内至少有2天登录游戏的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数，认为是2天有效注册用户的留存用户；",
                            "type": "percent",
                            "decimal": 2
                          },
                          {
                            "value": "second_login_ratio",
                            "metric_key": "second_login_ratio",
                            "enName": "2nd Order Login%",
                            "cnName": "二阶登录比",
                            "rainbowKey": "",
                            "explainEn": "2nd Order Login%: 3-day valid retained users / 3-day valid registers.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering.\n3-day valid retained users: the number of 3-day valid registered users who login within the eighth day and the fourteenth day from the day of registering. Considered as the retention users of 3-day valid registers.",
                            "explainCn": "二阶登录比=3天有效注册留存用户数/3天有效注册用户数\n3天有效注册留存用户：3天有效注册用户数中，在8-14天有登录行为的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数",
                            "type": "percent",
                            "decimal": 2
                          }
                        ]
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "DateComparisonMetricsTrend",
                      "props": {
                        "config": {
                          "subTitleCom": [
                            {
                              "titleEn": "Statistics Date",
                              "titleCn": "统计日期",
                              "subTitle1En": "Average",
                              "subTitle1Cn": "平均值",
                              "subTitle2En": "Sum",
                              "subTitle2Cn": "汇总值",
                              "subTitle3En": "Max",
                              "subTitle3Cn": "最大值"
                            },
                            {
                              "titleEn": "Contrast Date",
                              "titleCn": "对比日期",
                              "subTitle1En": "Average",
                              "subTitle1Cn": "平均值",
                              "subTitle2En": "Sum",
                              "subTitle2Cn": "汇总值",
                              "subTitle3En": "Max",
                              "subTitle3Cn": "最大值"
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "ComparisonTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/comparison_analysis/date/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/comparison_analysis/date/overall_performance/download"
                  },
                  "dataKey": "date_comparison",
                  "hasReqMetrics": true,
                  "componentMetrics": [
                    {
                      "Day": [
                        {
                          "metricKey": "total_users",
                          "reqMetricKey": "total_users",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 105,
                          "cnWidth": 112,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 160,
                          "enName": "TNU",
                          "cnName": "总注册用户数",
                          "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (userid deduplicated).",
                          "explainCn": "累计至统计日的注册用户总数(userid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_users",
                          "reqMetricKey": "new_users",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 85,
                          "cnWidth": 85,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "New",
                          "cnName": "新进用户",
                          "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (userid deduplicated).",
                          "explainCn": "统计周期内新注册用户数(userid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "active_users",
                          "reqMetricKey": "active_users",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 85,
                          "cnWidth": 120,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "DAU",
                          "cnName": "日活跃",
                          "explainEn": "Daily Active Users.Number of users who have logged in to the game during the statistical period (userid deduplicated).",
                          "explainCn": "统计周期内登录过游戏的用户数(userid数去重)。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "net_revenue",
                          "reqMetricKey": "net_revenue",
                          "enPercentWidth": 340,
                          "cnPercentWidth": 220,
                          "enWidth": 340,
                          "cnWidth": 180,
                          "enContrastWidth": 340,
                          "cnContrastWidth": 220,
                          "enName": "Revenue After Refund & Tax($)",
                          "cnName": "净收入($)",
                          "explainEn": "During the statistical period, the net sales revenue of 4 sales platforms, including Steam, Epic, Xbox, and Playstation,Revenue After Refund & Tax excludes refunds and is net of taxes",
                          "explainCn": "统计周期内，4个销售平台的销售净收入，包括Steam 、Epic、Xbox 、Playstation，净收入不包含退款，并且扣除了税费",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "revenue_after_chargeback",
                          "reqMetricKey": "revenue_after_chargeback",
                          "enPercentWidth": 340,
                          "cnPercentWidth": 220,
                          "enWidth": 340,
                          "cnWidth": 200,
                          "enContrastWidth": 340,
                          "cnContrastWidth": 220,
                          "enName": "Revenue After Refund($)",
                          "cnName": "收入(剔除退款)($)",
                          "explainEn": "The net sales amount of the game all products (Base Game、 dlc,bundle、 mtx..) is equal to the sum of the sales amount of the game's various platforms,the sales amount of each platform = total sales amount - refund amount,\\nNoted: this amount does not deduct steam/Epic platform share, and does not include the sales amount of retail actiyation code (humble bundle, hevbox...).\\n Data source: Steam/Epic/XBOX/PlayStation platforms\\n Time zone: Steam sales data is in UTC-8 time zone,EpicXBOX/PlayStation sales data is in UTC+0 time zone.",
                          "explainCn": "游戏所有产品（完整游戏、dlc、bundle、mtx...）的净销售额等于游戏各平台销售额的总和，剔除退款金额。\\n注：未扣除平台分成数据且不包含第三方销售渠道的金额（humble Bundle、heybox...）。\\n 数据来源： Steam/Epic/XBOX/PlayStation平台\\n时区： Steam 销售数据采用 UTC-8 时区，Epic/XBOX/PlayStation 销售数据采用 UTC+0 时区",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "units_number",
                          "reqMetricKey": "units_number",
                          "enPercentWidth": 280,
                          "cnPercentWidth": 230,
                          "enWidth": 290,
                          "cnWidth": 155,
                          "enContrastWidth": 340,
                          "cnContrastWidth": 170,
                          "enName": "Base Game Units After Refund",
                          "cnName": "本体拷贝净销量",
                          "rainbowKey": "Pc Units",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "gross_revenue",
                          "reqMetricKey": "gross_revenue",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 160,
                          "enWidth": 160,
                          "cnWidth": 160,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Revenue($)",
                          "cnName": "收入($)",
                          "explainEn": "Total sales amount Noted：this amount does not deduct steam/Epic platform share, and does not include the sales amount of retail activation code（humble bundle、heybox...). Data source： Steam/Epic/XBOX/PlayStation platforms Time zone： Steam sales data is in UTC-8 time zone,Epic/XBOX/PlayStation sales data is in UTC+0 time zone.",
                          "explainCn": "总销售金额 注：此金额不扣除Steam/Epic平台分成，也不包含零售激活码的销售金额（humble Bundle、heybox...）。数据来源： Steam/Epic/XBOX/PlayStation 平台时区： Steam 销售数据采用 UTC-8 时区，Epic/XBOX/PlayStation 销售数据采用 UTC+0 时区",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "units_revenue",
                          "reqMetricKey": "units_revenue",
                          "enPercentWidth": 380,
                          "cnPercentWidth": 240,
                          "enWidth": 380,
                          "cnWidth": 185,
                          "enContrastWidth": 440,
                          "cnContrastWidth": 240,
                          "enName": "Base Game Revenue After Refund & Tax",
                          "cnName": "本体拷贝收入",
                          "explainEn": "During the statistical period, the net sales revenue of the game itself includes the sales of the game itself in full game, edition, package and other products. Data Source: Platform Sales Reports",
                          "explainCn": "统计周期内，游戏本体的净销售收入，包括full game，eddition，package等产品里的游戏本体销售额.数据来源：Platform Sales Reports",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_revenue",
                          "reqMetricKey": "mtx_revenue",
                          "enPercentWidth": 250,
                          "cnPercentWidth": 250,
                          "enWidth": 230,
                          "cnWidth": 160,
                          "enContrastWidth": 230,
                          "cnContrastWidth": 210,
                          "enName": "In-Game Revenue",
                          "cnName": "内购收入",
                          "explainEn": "The total amounts from microtransactions in the statistical period.",
                          "explainCn": "统计周期内，游戏内购收入总金额",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_payers",
                          "reqMetricKey": "mtx_payers",
                          "enPercentWidth": 230,
                          "cnPercentWidth": 230,
                          "enWidth": 150,
                          "cnWidth": 112,
                          "enContrastWidth": 230,
                          "cnContrastWidth": 190,
                          "enName": "In-Game Payer",
                          "cnName": "内购付费人数",
                          "explainEn": "Total number of users who have in-game payment behaviors in the statistical period (deduplicated)",
                          "explainCn": "统计期间内有游戏内付费行为的用户总数（去重）",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_payer_rate",
                          "reqMetricKey": "mtx_payer_rate",
                          "enPercentWidth": 220,
                          "cnPercentWidth": 220,
                          "enWidth": 165,
                          "cnWidth": 150,
                          "enContrastWidth": 220,
                          "cnContrastWidth": 190,
                          "enName": "In-Game Payer%",
                          "cnName": "内购付费渗透率",
                          "explainEn": "Number of In-Game paying users/Number of active users during the statistical period",
                          "explainCn": "内购付费人数/统计周期内的活跃人数",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_arpu",
                          "reqMetricKey": "mtx_arpu",
                          "enPercentWidth": 220,
                          "cnPercentWidth": 220,
                          "enWidth": 145,
                          "cnWidth": 112,
                          "enContrastWidth": 220,
                          "cnContrastWidth": 190,
                          "enName": "In-Game ARPU",
                          "cnName": "内购ARPU",
                          "explainEn": "In-Game Revenue/Number of active users during the statistical period",
                          "explainCn": "内购收入/统计周期内的活跃人数",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_arppu",
                          "reqMetricKey": "mtx_arppu",
                          "enPercentWidth": 220,
                          "cnPercentWidth": 220,
                          "enWidth": 155,
                          "cnWidth": 150,
                          "enContrastWidth": 220,
                          "cnContrastWidth": 190,
                          "enName": "In-Game ARPPU",
                          "cnName": "内购付费ARPPU",
                          "explainEn": "In-Game Revenue/Number of In-Game pay users during the statistical period",
                          "explainCn": "内购收入/统计期间内的内购付费人数",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d1",
                          "reqMetricKey": "d1",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 80,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D1",
                          "cnName": "D1留存",
                          "explainEn": "The retention rate of new register users on day 1. Number of retained users on day 1 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D1留存=xx注册日期第1天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d2",
                          "reqMetricKey": "d2",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 80,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D2",
                          "cnName": "D2留存",
                          "explainEn": "The retention rate of new register users on day 2. Number of retained users on day 2 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D2留存=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d3",
                          "reqMetricKey": "d3",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 80,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D3",
                          "cnName": "D3留存",
                          "explainEn": "he retention rate of new register users on day 3. Number of retained users on day 3 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D3留存=xx注册日期第3天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d4",
                          "reqMetricKey": "d4",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 80,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D4",
                          "cnName": "D4留存",
                          "explainEn": "The retention rate of new register users on day 4. Number of retained users on day 4 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D4留存=xx注册日期第4天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d5",
                          "reqMetricKey": "d5",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 80,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D5",
                          "cnName": "D5留存",
                          "explainEn": "The retention rate of new register users on day 5. Number of retained users on day 5 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D5留存=xx注册日期第5天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d6",
                          "reqMetricKey": "d6",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 80,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D6",
                          "cnName": "D6留存",
                          "explainEn": "The retention rate of new register users on day 6. Number of retained users on day 6 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D6留存=xx注册日期第6天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d7",
                          "reqMetricKey": "d7",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 80,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D7",
                          "cnName": "D7留存",
                          "explainEn": "The retention rate of new register users on day 7. Number of retained users on day 7 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D7留存=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d14",
                          "reqMetricKey": "d14",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 100,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D14",
                          "cnName": "D14留存",
                          "explainEn": "The retention rate of new register users on day 14. Number of retained users on day 14 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D14留存=xx注册日期第14天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d30",
                          "reqMetricKey": "d30",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 140,
                          "enWidth": 70,
                          "cnWidth": 100,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D30",
                          "cnName": "D30留存",
                          "explainEn": "The retention rate of new register users on day 30. Number of retained users on day 30 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "D30留存=xx注册日期第30天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "pcu",
                          "reqMetricKey": "pcu",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 160,
                          "enWidth": 77,
                          "cnWidth": 112,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 160,
                          "enName": "PCU",
                          "cnName": "最高同时在线",
                          "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "acu",
                          "reqMetricKey": "acu",
                          "enPercentWidth": 140,
                          "cnPercentWidth": 160,
                          "enWidth": 77,
                          "cnWidth": 112,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 160,
                          "enName": "ACU",
                          "cnName": "平均同时在线",
                          "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "aot_hour",
                          "reqMetricKey": "aot_hour",
                          "enPercentWidth": 240,
                          "cnPercentWidth": 220,
                          "enWidth": 164,
                          "cnWidth": 190,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 220,
                          "enName": "Avg.Playtime(h)",
                          "cnName": "平均在线时长(小时)",
                          "rainbowKey": "Pc Avg.Playtime(h)",
                          "explainEn": "",
                          "explainCn": "",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "alc",
                          "reqMetricKey": "alc",
                          "enPercentWidth": 230,
                          "cnPercentWidth": 150,
                          "enWidth": 160,
                          "cnWidth": 140,
                          "enContrastWidth": 230,
                          "cnContrastWidth": 150,
                          "enName": "Sessions per user",
                          "cnName": "平均登录次数",
                          "explainEn": "Sessions per user.\nDaily：Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly：Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                          "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户。\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户。\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "retention_users",
                          "reqMetricKey": "retention_users",
                          "enPercentWidth": 260,
                          "cnPercentWidth": 140,
                          "enWidth": 210,
                          "cnWidth": 171,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 140,
                          "enName": "DAU Retention Users",
                          "cnName": "日活留存",
                          "explainEn": "The number of users who logged in during the recent 7 days(T-1~T-7) and have logged in to the game during the statistical period (deduplicated).",
                          "explainCn": "日活跃构成中的留存用户数，统计周期前一个周期 前7天(T-1~T-7) 登录了游戏并且在统计周期当期也有登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_users",
                          "reqMetricKey": "churn_users",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 140,
                          "enWidth": 114,
                          "cnWidth": 95,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 140,
                          "enName": "Churn Users",
                          "cnName": "日流失",
                          "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                          "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数n月：上个月登录了并且在本月未登录的用户数。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "churn_rate",
                          "reqMetricKey": "churn_rate",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 80,
                          "cnWidth": 95,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "Churn%",
                          "cnName": "流失率",
                          "explainEn": "Daily: Churn Users / Active Users Yesterday.\nWeekly: Churn Users / Active Users Last Week.\nMonthly: Churn Users / Active Users Last Month.",
                          "explainCn": "日=日流失用户/昨日的活跃用户\n周=周流失用户/上周的活跃用户\n月=月流失用户/上月的活跃用户。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "return_users",
                          "reqMetricKey": "return_users",
                          "enPercentWidth": 250,
                          "cnPercentWidth": 140,
                          "enWidth": 170,
                          "cnWidth": 95,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 140,
                          "enName": "DAU Return Users",
                          "cnName": "日回流",
                          "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                          "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存。",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d2",
                          "reqMetricKey": "weighted_d2",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 122,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D1",
                          "cnName": "加权D1留存",
                          "explainEn": "Day 1 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 1 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权D1留存=游戏上线之日起至统计日对（新注册用户数*新增次日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "weighted_d3",
                          "reqMetricKey": "weighted_d3",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 122,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D2",
                          "cnName": "加权D2留存",
                          "explainEn": "Day 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 2 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权D2留存=游戏上线之日起至统计日对（新注册用户数*新增2日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d7",
                          "reqMetricKey": "weighted_d7",
                          "enPercentWidth": 200,
                          "cnPercentWidth": 200,
                          "enWidth": 122,
                          "cnWidth": 122,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D6",
                          "cnName": "加权D6留存",
                          "explainEn": "Day 6 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 6 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权D6留存=游戏上线之日起至统计日对（新注册用户数*新增6日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d14",
                          "reqMetricKey": "weighted_d14",
                          "enPercentWidth": 210,
                          "cnPercentWidth": 210,
                          "enWidth": 132,
                          "cnWidth": 132,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Weighted D13",
                          "cnName": "加权D13留存",
                          "explainEn": "Day 13 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 13 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权D13留存=游戏上线之日起至统计日对（新注册用户数*新增13日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "first_login_ratio",
                          "reqMetricKey": "first_login_ratio",
                          "enPercentWidth": 236,
                          "cnPercentWidth": 160,
                          "enWidth": 160,
                          "cnWidth": 145,
                          "enContrastWidth": 236,
                          "cnContrastWidth": 160,
                          "enName": "1st Order Login%",
                          "cnName": "一阶登录比",
                          "explainEn": "1st Order Login%: 3-day valid registers / 2-day valid registers.\n2-day valid registers: the number of users who login for at least two days within seven days, starting from the day of registering.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering. Considered as the retention users of 2-day valid registers.",
                          "explainCn": "一阶登录比=3天有效注册用户数/2天有效注册用户数\n2天有效注册用户：从注册日开始计算，七天内至少有2天登录游戏的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数，认为是2天有效注册用户的留存用户；",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "second_login_ratio",
                          "reqMetricKey": "second_login_ratio",
                          "enPercentWidth": 250,
                          "cnPercentWidth": 250,
                          "enWidth": 160,
                          "cnWidth": 145,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 250,
                          "enName": "2nd Order Login%",
                          "cnName": "二阶登录比",
                          "explainEn": "2nd Order Login%: 3-day valid retained users / 3-day valid registers.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering.\n3-day valid retained users: the number of 3-day valid registered users who login within the eighth day and the fourteenth day from the day of registering. Considered as the retention users of 3-day valid registers.",
                          "explainCn": "二阶登录比=3天有效注册留存用户数/3天有效注册用户数\n3天有效注册留存用户：3天有效注册用户数中，在8-14天有登录行为的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        }
                      ]
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};

